import { VerticalStepper } from '@ui/VerticalStepper'
import { Content, DefaultPage } from '@shared/layout/DefaultPage'

export const TestPage = () => {
	return (
		<DefaultPage noPadding>
			<Content style={{ '--background': '#f3f4f5' }}>
				<VerticalStepper />
			</Content>
		</DefaultPage>
	)
}
